import { render, staticRenderFns } from "./PageSearchword.vue?vue&type=template&id=0efcbbd6&"
import script from "./PageSearchword.vue?vue&type=script&lang=ts&"
export * from "./PageSearchword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports